import * as React from 'react';
import { Props } from 'react';

import './HomeView.scss';
import i18next from 'i18next';

const travel = {
    photo: require('../../../assets/road_travel.png'),
    trip_link: 'https://priceless.road.travel/trips/main?utm_source=konsierge&utm_medium=button&utm_campaign=chatbot&utm_content=landing&utm_term=routes'
};

interface HomeViewProps extends Props<HomeView> {
    channelId: string;
}

export class HomeView extends React.Component<HomeViewProps> {
    render() {
        /*const {channelId} = this.props;*/
        return (
            <div className='travels-container'>
                <div className='travels-container-content'>
                    <div className='travels-photo'>
                        <img src={travel.photo}/>
                    </div>
                    <div className='travels-description'>
                        <div className='travels-description-content'>
                            <div>
                                {i18next.t('road_travel_is_ready_solution')}
                            </div>
                        </div>
                        <div className='travels-description-content'>
                            <div>
                                {i18next.t('get_personal_offer')}
                            </div>
                        </div>
                        <div className='travels-description-content'>
                            <div>
                                {i18next.t('specially_for_Mastercard_clients')}
                            </div>
                        </div>
                    </div>
                </div>
                <a href={travel.trip_link}>
                    <div className='footer-button__wrapper'>
                        <div className='button blue center'>{i18next.t('get_road')}</div>
                    </div>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Travels/Home/HomeView.tsx